<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{$t("Delivery inspection")}}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <div v-else>
            <v-card raised  class="mb-4">
              <div v-for="header in form.inspection.Header" :key="header.id">
                  <v-flex xs12>
                    <v-layout v-if="isImageHeader(form.inspection, header)" row wrap class="textsize-svs" :style="getHeaderStyle(header)" style="padding: 0px 0px 0px 14px">
                        <v-flex d-flex xs5>{{getCameraName(form.inspection, header)}}</v-flex><v-flex d-flex xs7>
                          <img :src="getImageValue(form.inspection, header)" style="width:100%;max-width: 400px;height:auto;"></v-flex>
                    </v-layout>
                    <v-layout v-else row wrap class="textsize-svs" :style="getHeaderStyle(header)" style="padding: 0px 0px 0px 14px">
                        <v-flex d-flex xs5>{{$t(header.Field)}}</v-flex><v-flex d-flex xs7>{{getHeaderValue(form.inspection, header)}}</v-flex>
                    </v-layout>
                </v-flex>
              </div>
            </v-card>
            <v-card raised>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-form ref="form" v-model="valid">
                      <v-layout row wrap>
                        <template v-for="(question, index) of form.inspection.Questions">
                          <v-flex xs12 :key="index">
                            <finder :question="question"></finder>
                            <v-divider class="mb-4"></v-divider>
                          </v-flex>
                        </template>
                        <v-flex xs12 text-center>
                          <p>{{$t("Inspected by")}}: <span class="font-weight-bold">{{User}}</span></p>
                        </v-flex>
                        <v-flex text-center>
                          <v-btn @click.prevent="submitInspection" color="success" :loading="submitting || buzy" type="primary">{{$t("Submit")}}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>

</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as DeliveryInspection from '@/modules/delivery-inspection/delivery-inspection'
import Finder from '@/modules/delivery-inspection/components/Finder'
import * as Security from '@/core/security'
import * as DateUtil from '@/core/date'
import * as Utils from '@/core/utils'

export default {
  mixins: [filters],
  name: 'deliveryInspection',
  props: ['id'],
  components: {
    Finder
  },
  data: () => ({
    form: {
      inspection: null
    },
    valid: true,
    loading: true,
    submitting: false,
    buzy: false
  }),
  computed: {
    User () {
      return Security.user.token.User
    }
  },
  methods: {
    hasDuplicates (array) {
      return new Set(array).size !== array.length
    },
    isImageHeader (item, header) {
      let result = false
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre = header.Field.substring(0, 13)
          const post = header.Field.substring(11, 50)
          if (pre === 'ImageCapture_' && post) {
            try {
              const jsonStr = item.WeightRegistration.ImageData
              // eslint-disable-next-line no-unused-expressions
              JSON.parse(jsonStr)[post] // We assume that customdata is stored as json. E.g. {Cam1: '<base64 image>'}. Lets try to parse it.
              result = true
            } catch (error) {
              console.log('Warning: ', error.message)
              result = false
            }
          }
        }
      }
      return result
    },
    getCameraName (item, header) {
      let result = 'Cam'
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre = header.Field.substring(0, 13)
          const post = header.Field.substring(13, 50)
          if (pre === 'ImageCapture_' && post) {
            try {
              result = post
            } catch (error) {
              console.log('Warning: ', error.message)
            }
          }
        }
      }
      return result
    },
    getImageValue (item, header) {
      let result = 'iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAELUExURSM3XTsxU2MqRGQqQ1csSCU2XDkxVGMqQ2coQkcuTzUyV7wbIs8YG88ZG8sYHFEtTEIwUbobIs8YGp8gLyo1WnwlO5wgLyY2XDgyVbIcJqoeKTE0WDkyVcEaIcsZHEkuTzIzV6geKrMdJjsyVIMlOZogMJ4fLrsaIkYvUDsyVcQaH9AYGs4YG8MaH1EuTJ4gLm4oQCQ3XWkoQ5QiMl8qRscZHs0YG5ghL8UaHscZHUQwUFMsS8EaH5YhMi41WYwjNNAZG4wiNEcuUL4aIqAfLUIwUsgZH8MZHj8xUzoyVLkbIqweKTI0V5QhMc4YGoUjN2AqRXIoPmopQTAzWDYzVXMoPnIoP2kpQio0WgVuYekAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACsSURBVChTjY1FFgJBDEQDg5NGggzu7oO7uzvc/yTQMBt21Cb1U3kV+EcKpSCo1NxptDr9exiMyEzmt7FYyWbngQORnCK43OTxcgafHykQDIUxEv0wQAwR4wlKpmSGdCbLcixfkBFALBIhlSQZQSoHGDGsfF5zrtbqjSZhqy0vOl3W6w9wSKPvyXiC0z7M5oSLJefVmm22Eog7pP2B1x5P5wsPrqfb/fHk7kcAL9jCEsf2hIaRAAAAAElFTkSuQmCC'
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre2 = header.Field.substring(0, 13)
          const post = header.Field.substring(13, 50)
          // Use prefixed 'CustomData_' in Field to support custom data (e.g. CustomData_FuelType or CustomData_TreatmentProcesses).
          if (pre2 === 'ImageCapture_' && post) {
            try {
              const jsonStr = item.WeightRegistration.ImageData
              result = 'data:image/png;base64,' + JSON.parse(jsonStr)[post] // We assume that customdata is stored as json. E.g. {Cam1: '<base64 image>'}
            } catch (error) {
              console.log('Warning: ', error.message)
            }
          }
        }
      }
      return result
    },
    getHeaderValue (item, header) {
      let result = ''
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        if (item.WeightRegistration) {
          const pre = header.Field.substring(0, 11)
          const post = header.Field.substring(11, 50)
          // Use prefixed 'CustomData_' in Field to support custom data (e.g. CustomData_FuelType or CustomData_TreatmentProcesses).
          if (pre === 'CustomData_' && post) {
            try {
              const jsonStr = item.WeightRegistration.CustomData
              result = JSON.parse(jsonStr)[post] // We assume that customdata is stored as json. E.g. {FuelType: 'Bioolje'}
            } catch (error) {
              result = error.message
            }
          } else {
            result = item.WeightRegistration[header.Field]
          }
        }
      } else {
        if (header.Source === 'DeliveryInspection') {
          result = item[header.Field]
        }
      }
      if (header.AsDate) result = DateUtil.getSmartDate(result)
      return result
    },
    getHeaderStyle (header) {
      let result = ''
      if (Object.prototype.hasOwnProperty.call(header, 'Style')) {
        result = header.Style
      }
      return result
    },
    async submitInspection () {
      await Utils.waitFor(_ => this.CalcBuzy())
      this.submitting = true
      if (this.$refs.form.validate()) {
        const res = await DeliveryInspection.submitInspection({
          id: this.id,
          questions: this.form.inspection.Questions
        })
        if (!res.failed) this.$router.push({ name: 'registrations' })
      }
      this.submitting = false
    },
    CalcBuzy () {
      let res = false
      if (this?.form?.inspection?.Questions) {
        this.form.inspection.Questions.forEach(question => {
          if (!res && question.buzy !== undefined) res = question.buzy
        })
      }
      this.buzy = res
      return !res // return true if not buzy
    }
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    const res = await DeliveryInspection.loadInspection(this.$route.params.id)
    this.loading = false
    if (!res.failed) {
      if (res.data != null) {
        this.form.inspection = res.data
        // Now set InProgress to true
        await DeliveryInspection.setInspectionInProgress({ id: this.$route.params.id, inProgress: true })
      } else {
        this.$root.$message.showWarning(this.$t('Data does not exist'))
        this.$router.push('/registrations')
      }
    }
  },
  async destroyed () {
    // When leaving the page, make sure that InProgress is set to false.
    await DeliveryInspection.setInspectionInProgress({ id: this.id, inProgress: false })
  }
}
</script>

<style>
  p {
    font-size: 16px;
  }
</style>
